import { LogNguoiDung } from "../lognguoidung/LogNguoiDung";

export class DonNghiPhep{
    "id": number;
    "idNhanVien": number;
    "tuNgay": Date;
    "denNgay": Date;
    "tongSoNgayNghi": number;
    "soNgayPhepConLai": number;
    "lyDo": string;
    "kinhGui": string;
    "diaDiemNghiPhep": string;
    "tongSoNgayPhep": number;
    "soNgayDaNghiPhep": number;
    "trangThai": number;
    "quyenPheDuyet": boolean;
    "quyenSua": boolean;
    "quyenYKien": boolean;
    "idLoaiNghiPhep": number;
    "tenNhanVien": string;
    "idNguoiDuyet": number;
    "idNguoiYKien1": number | null;
    "idNguoiYKien2": number | null;
    "idNguoiYKien3": number | null;
    "tenNguoiDuyet": string;
    "tenNguoiYKien1": string;
    "tenNguoiYKien2": string;
    "tenNguoiYKien3": string;
    "tenDonVi": string;
    "tenChucVu": string;
    "ngayKhoiTao": Date;
    "ngayCapNhat": Date | null;
    "tenLoaiNghiPhep": string;
    "logs": Array<LogNguoiDung>
}

export class NguoiLienQuan_DonNghiPhep{
    "hoTen": string;
    "tenDonVi": string;
    "idDonNghiPhep": number;
    "idNhanVienLienQuan": number;
}

export class DuyetDonNghiPhep{
    "idDonNghiPhep": number;
    "idNhanVienDuyet": number;
    "idChucVuNVDuyet": number;
    "trangThai": number;
    "lyDoTuChoi": string;
    "tenNVDuyet": string;
    "chucVuNVDuyet": string;
    "ngayKhoiTao": Date;
}
export class TimKiemDonNghiPhepPagingResponse {
    "data": Array<DonNghiPhep>;
    "recordsTotal": number;
    "maxPage": number;
    "pageCurrent": number;
    "pageListShow": Array<number>;
}

export class DanhSachNhanVienDuocDuyet {
    "idNhanVienDuyet": number;
    "idNhanViens": Array<number>
}

export class DanhSachNhanVienDuocYKien {
    "idNhanVienYKien": number;
    "idNhanViens": Array<number>
}

export class CauHinhReponse {
    "id": number;
    "idNhanVien": number;
    "idNhanVienDuyet": number;
    "idDonVi": number;
}

export class CauHinhNguoiYKienReponse {
    "id": number;
    "idNhanVien": number;
    "idNhanVienYKien": number;
    "idDonVi": number;
}

export class CauHinhNguoiMacDinhReponse {
    "idNhanVien": number;
    "idNhanVienDuyet": number;
    "idNhanVienYKien": number;
    "idGiamDoc": number;
}

export class NgayPhepTrongNamResponse {
    "id": number;
    "tuNgay": Date;
    "denNgay": Date;
    "phepTieuChuan": number;
    "phepThamNien": number;
    "soNgayDaNghi": number;
    "soNgayPhepTrongNam": number;
    "nam": number;
    "tenDonVi": string;
    "tenChucVu": string;
    "tenNhanVien": string;
    "idNhanVien": number;
    "ngayVaoLam": string;
}

export class TimKiemNgayPhepTrongNamPagingResponse {
    "data": Array<NgayPhepTrongNamResponse>;
    "recordsTotal": number;
    "maxPage": number;
    "pageCurrent": number;
    "pageListShow": Array<number>;
}

export class TimKiemDonNghiPhepRequest{
    "tuKhoa": string | null;
    "ngayTaoTuNgay": Date | null;
    "ngayTaoDenNgay": Date | null;
    "ngayBatDauTuNgay": Date | null;
    "ngayBatDauDenNgay": Date | null;
    "ngayKetThucTuNgay": Date | null;
    "ngayKetThucDenNgay": Date | null;
}